module.exports = __webpack_public_path__ + "static/media/gifPlaceholder.bfdb2d44.jpg";